import { Box, Typography } from '@mui/material';
import { useAtom } from 'jotai';
import { useParams } from 'react-router-dom';
import { AccountManagementViews } from './constants';
import { ViewContainer } from './containers';
import OrganizationSettingView from './organization-setting';
import ProfileView from './profile-view';
import AccountManagementSideBar from './side-bar';

const AccountManagement = () => {
    const params = useParams();
    const appRoute = params?.view;

    const views = {
        [AccountManagementViews.PROFILE]: <ProfileView />,
        [AccountManagementViews.ORGANIZATION_SETTINGS]: <OrganizationSettingView />,
    };

    return (
        <ViewContainer>
            <AccountManagementSideBar />
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                }}
            >
                {views[appRoute] || null}
            </Box>
        </ViewContainer>
    );
};

export default AccountManagement;
